/**
 * ButtonWithTooltip
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import Pficon from 'components/Pficon';

const ButtonWithTooltip = ({
  disabled,
  onClick,
  iconType = 'arrow_down',
  iconClasses,
  tooltip = '',
  tooltipValues = {},
  showTooltipWhenDisabled,
  buttonClasses = '',
  buttonStyle = {},
  buttonStyleDisabled = {},
  tooltipPlacement = 'top',
  tooltipOverlayStyle = {},
  iconSize,
  text = '',
  'data-testid': dataTestid,
  ...otherButtonProps
}) => {
  const buttonText = (
    <span
      className={classNames({
        'flex flex-justify-center flex-align-items--center': text,
      })}
    >
      <Pficon
        className={
          iconClasses
            ? classNames(iconClasses)
            : classNames('text-size-secondary', {
                'color-grey-10': !disabled,
                'color-grey-7': disabled,
              })
        }
        type={iconType}
        size={iconSize}
      />
      {text && <span className="margin-left-xxs">{text}</span>}
    </span>
  );
  const actionButton =
    disabled && showTooltipWhenDisabled ? (
      <span
        className={classNames(
          buttonClasses,
          'border-none',
          'shadow-none',
          'padding-vertical-xxs',
          'padding-horizontal-xxs',
        )}
        data-testid={dataTestid}
        style={buttonStyleDisabled}
      >
        {buttonText}
      </span>
    ) : (
      <Button
        type="button"
        size="small"
        shape="circle"
        className={classNames(
          buttonClasses,
          'outline-blue',
          'border-none',
          'shadow-none',
          'padding-none',
          'display-flex flex-items-center flex-justify-center',
          { 'color-grey-10 color-blue-6-hover': !disabled },
        )}
        style={buttonStyle}
        ghost
        disabled={disabled}
        onClick={onClick}
        data-testid={dataTestid}
        {...otherButtonProps}
      >
        {buttonText}
      </Button>
    );

  const showTooltip = tooltip && (showTooltipWhenDisabled || !disabled);

  return showTooltip ? (
    <Tooltip
      placement={tooltipPlacement}
      arrowPointAtCenter
      overlayClassName="tooltip-light"
      overlayStyle={tooltipOverlayStyle}
      trigger="hover"
      title={<FormattedMessage {...tooltip} values={tooltipValues} />}
    >
      {actionButton}
    </Tooltip>
  ) : (
    actionButton
  );
};

ButtonWithTooltip.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  iconType: PropTypes.string,
  iconClasses: PropTypes.array,
  tooltip: PropTypes.any,
  showTooltipWhenDisabled: PropTypes.bool,
  buttonClasses: PropTypes.string,
  buttonStyle: PropTypes.object,
  tooltipPlacement: PropTypes.string,
};

export default ButtonWithTooltip;
